import axios from "axios";
import { getTokenData } from "../../../../shared/utils/utils";
import { ApiError } from "../../../../shared/utils/errors/ApiError";

export async function ChannelCheck({ code, name }) {
  try {
    const { token, client_id } = await getTokenData();

    if (!token) {
      throw new ApiError({
        error: "auth_error",
        message: "Token de autenticação não encontrado",
      });
    }

    if (!client_id) {
      throw new ApiError({
        error: "auth_error",
        message: "ID do cliente não encontrado",
      });
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/channels/whatsappweb/save`,
      { code, name },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
          Client_ID: client_id,
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Erro ao salvar canal WhatsApp Web:", error);

    if (axios.isAxiosError(error)) {
      const apiError = error.response?.data;

      if (apiError?.error && apiError?.message) {
        throw new ApiError(apiError);
      }
    }

    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError({
      error: "unknown_error",
      message: "Erro ao salvar canal WhatsApp Web",
    });
  }
}
